import classNames from "classnames";

import StoryblokLink from "../link/StoryblokLink";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";

import styles from "./bannerPanel.module.scss";

function BannerPanel({ desktop_image, mobile_image, link }) {
  const Wrapper = link ? StoryblokLink : "div";
  const linkProps = link ? { linkObject: link } : {};

  const desktopClasses = classNames({
    [styles.desktop]: true,
    [styles.noMobileImage]: !mobile_image?.filename
  });

  return (
    <Wrapper
      className={styles.banner}
      {...linkProps}
    >
      {desktop_image?.filename &&
        <div className={desktopClasses}>
          <StoryblokImageBasic image={desktop_image} />
        </div>
      }
      {mobile_image?.filename &&
        <div className={styles.mobile}>
          <StoryblokImageBasic image={mobile_image} />
        </div>
      }
    </Wrapper>
  );
}

export default BannerPanel;
